const GENERIC_PLAN_ICONS = {
    polyline: 'descripcion_escenario/via_comunicacion.png',
    polygon: 'descripcion_escenario/sector.png'
};
export function buildPerimetroLegendItem(label, resolved, catalog) {
    const entry = catalog.find((line) => line.style === resolved.styleKey);
    const tipo = label?.label || entry?.label;
    const icon = label?.src || entry?.src;
    if (!tipo || !icon)
        return null;
    return { tipo, icon, color: label?.color || resolved.color };
}
export function buildPlanOperacionesLegendItem(geometryType, label, symbolUrl) {
    const icon = label?.src || (geometryType === 'point' ? symbolUrl : GENERIC_PLAN_ICONS[geometryType]);
    if (!icon)
        return null;
    return { plan: geometryType, tipo: label?.label || '', icon, generic: !label?.label };
}
